export enum FeedbackReaction {
  ThumbsUp = 'ThumbsUp',
  ThumbsDown = 'ThumbsDown',
}
